import { graphql } from "gatsby"
import _ from "lodash"
import React from "react"
import Footer from "../../../components/shared/footer"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"
import FixedHeaderSpacer from "../../atoms/fixed-header-spacer"
import Link from "../../atoms/link"
import InternalRoutes from "../../util/internal-routes"
import ListingBreadcrumbs from "../article-listing/breadcrumbs"
import ListingHeader from "../article-listing/header"
import CategoryBody, { IArticleGroup } from "./category-body"

/**
 * Template for generated Contentful category pages
 * @param data - articles from this category grouped by topic
 * @param pageContext - category
 */
const CategoryPage = ({
  data: { articlesGroupedByTopic },
  location,
  pageContext: category,
}) => {
  // Sort the article groups by count
  const sortedArticleGroups = articlesGroupedByTopic.group.sort((a, b) =>
    a.totalCount <= b.totalCount ? 1 : -1
  )

  // Clean up the data
  const sortedArticleGroupsWithSlug: IArticleGroup[] = sortedArticleGroups.map(
    (topic) => ({
      edges: topic.edges,
      totalCount: topic.totalCount,
      name: topic.fieldValue,
      slug: _.kebabCase(topic.fieldValue.toLowerCase()),
    })
  )

  return (
    <Layout showBackground={true} contactLightbox={true} location={location}>
      <SEO title={category.name} />
      <FixedHeaderSpacer />
      <ListingBreadcrumbs>
        <Link to={InternalRoutes.Blog()}>Home</Link>
        <Link to={InternalRoutes.Blog(category)}>{category.name}</Link>
      </ListingBreadcrumbs>
      <ListingHeader
        title={category.name}
        subtitle={`${sortedArticleGroups.length} Topic${
          sortedArticleGroups.length > 1 ? `s` : ``
        }`}
      />
      <CategoryBody
        category={category}
        articleGroups={sortedArticleGroupsWithSlug}
      />
      <Footer />
    </Layout>
  )
}

export default CategoryPage

export const categoryPageQuery = graphql`
  query ($slug: String) {
    articlesGroupedByTopic: allContentfulBlogPost(
      sort: { fields: publishDate, order: DESC }
      filter: { tags: { category: { slug: { eq: $slug } } } }
    ) {
      group(field: tags___topic___name, limit: 3) {
        edges {
          node {
            ...ContentfulBlogPostFragment
          }
        }
        fieldValue
        totalCount
      }
    }
  }
`
